import {isArray as _isArray} from 'lodash'

// Set equality check
// Ref: https://stackoverflow.com/a/44827922/1259696
export const isSetsEqual = (a, b) => a.size === b.size && [...a].every(value => b.has(value))

export const toArray = (item) => {
  if (item === undefined) {
    return []
  }

  return _isArray(item) ? item : [item]
}
